import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Heading, Text, VStack, SimpleGrid, Flex, Link, Icon, Button } from "@chakra-ui/react";
import { Newspaper, ExternalLink, ArrowRight } from "lucide-react";
import PRESS from "../../data/press";
import { useLang, useLocalPath, useText } from "../../i18n/lang";

const TEXT = {
  en: { title: "Travel Time in the press", intro: "Independent rankings and articles about our company.", read: "Read the article", all: "All press articles" },
  ro: { title: "Travel Time în presă", intro: "Clasamente și articole independente despre compania noastră.", read: "Citește articolul", all: "Toate articolele din presă" },
};

const year = (date) => date.slice(0, 4);

const HomePress = () => {
  const t = useText(TEXT);
  const lang = useLang();
  const localPath = useLocalPath();

  return (
    <Box py={{ base: 16, md: 24 }} bg="gray.50">
      <Container maxW="container.xl">
        <VStack spacing={4} textAlign="center" mb={{ base: 10, md: 14 }}>
          <Heading as="h2" fontFamily="Montserrat" fontWeight="700" fontSize={{ base: "2xl", md: "4xl" }} color="gray.800">
            {t.title}
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} color="gray.600">
            {t.intro}
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          {PRESS.map((article) => (
            <Flex
              key={article.url}
              direction="column"
              bg="white"
              borderRadius="xl"
              borderWidth="1px"
              borderColor="gray.100"
              p={{ base: 6, md: 7 }}
              boxShadow="0 10px 30px -18px rgba(15, 40, 80, 0.35)"
            >
              <Flex align="center" gap={3} mb={3}>
                <Flex w="40px" h="40px" borderRadius="lg" bg="blue.50" align="center" justify="center" flexShrink={0}>
                  <Icon as={Newspaper} boxSize={5} color="blue.500" />
                </Flex>
                <Box>
                  <Text fontWeight="700" color="gray.800" fontFamily="Montserrat">
                    {article.publisher}
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    {year(article.date)}
                  </Text>
                </Box>
              </Flex>
              <Text color="gray.700" fontSize="md" lineHeight="1.6" mb={4} flex="1">
                {article.summary[lang]}
              </Text>
              <Link href={article.url} isExternal color="blue.600" fontWeight="600" fontSize="sm" display="inline-flex" alignItems="center" gap={1.5}>
                {t.read}
                <Icon as={ExternalLink} boxSize={3.5} />
              </Link>
            </Flex>
          ))}
        </SimpleGrid>

        <Flex justify="center" mt={10}>
          <Button
            as={RouterLink}
            to={localPath("/presa")}
            onClick={() => window.scrollTo(0, 0)}
            variant="outline"
            colorScheme="blue"
            size="lg"
            rightIcon={<ArrowRight size={18} />}
          >
            {t.all}
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};

export default HomePress;
